export default "__VITE_ASSET__DvKmioYx__"